import React from 'react';
import './index.css';
//import {Motion, spring} from 'react-motion';
import GameWindow from './gameWindow';
import Player from './player';
import Speaker from './speaker';
import Credits from './credits';

export default class Menu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showMenu:true,
      difficulty:null,
      speakerOn: 'on',
      /*showCredits:false*/
    }
    this.handleClick = this.handleClick.bind(this)
    this.backToMenu = this.backToMenu.bind(this)
    this.setSound = this.setSound.bind(this)
    this.showCredits = this.showCredits.bind(this)
    this.hideCredits = this.hideCredits.bind(this)
  }

  handleClick (diff) {
    this.setState({difficulty:diff, showMenu:false})
  }

  backToMenu () {
    this.setState({showMenu:!this.state.showMenu})
  }

  setSound () {
    let audio = this.state.speakerOn === 'on' ? 'off' : 'on';
    localStorage.setItem("gameAudio",audio)
    this.setState({speakerOn:audio})
  }

  showCredits () {
    //this.setState({showCredits:true})
    const menu = document.getElementById("menu")
    menu.style.transform = 'translate3d(0px, -400px, 0px)';
  }

  hideCredits () {
    //this.setState({showCredits:false})
    const menu = document.getElementById("menu")
    menu.style.transform = 'translate3d(0px, 0px, 0px)';    
  }

  componentDidMount(){
    let audio = localStorage.getItem("gameAudio");
    if (audio === null) { //not initialized
      audio = 'on'
    }
    this.setState({speakerOn: audio})
  }

  render() {
    return (
      <div id='gameContainer'>
        { this.state.showMenu ?
        <div id="menu">
          <h1>Qwerty Run</h1>
          <h2 onClick={() => this.handleClick(1)}><span>Easy</span><span>Home Row Keys</span></h2>
          <h2 onClick={() => this.handleClick(2)}><span>Medium</span><span>All Keys</span></h2>
          <h2 onClick={() => this.handleClick(3)}><span>Hard</span><span>Words</span></h2>
          <h3 id="creditsBtn" onClick={() => this.showCredits()}><span>Credits</span></h3>
          <Player showMenu={this.state.showMenu} menu={true}/>
          <Speaker speakerOn={this.state.speakerOn} setSound={this.setSound} />
          <Credits hideCredits={this.hideCredits}/>
        </div>
        : <GameWindow difficulty={this.state.difficulty} backToMenu={this.backToMenu} showMenu={this.state.showMenu} speakerOn={this.state.speakerOn}/>
        }
      </div>
    )
  }
}



